import { useMemo } from "react";
import * as Styled from "./style";
import { isVideoLegacySeason, isVideoSeason, isVideoSpotLiveSeason } from "~/components/blocks/product/type-guard";
import { useQueryString } from "~/hooks/use-query-string";
import type { G_GetVideoQuery } from "~/lib/graphql";

type PlaybackCheckerTagProps = {
  videoData: G_GetVideoQuery["video"];
};
const HELP_URL =
  process.env.BUILD_MODE === "prd"
    ? "https://support.dmm.com/dmm-tv/article/47842"
    : "https://preview.support.dmm.com/dmm-tv/article/47842";

/**
 * 動画再生の注釈を表示するコンポーネント
 * - コンテンツ保護対象作品(drmLevel.hasStrictProtectionがTrue)の場合 : 注釈を表示すること
 * - コンテンツ保護対象外作品(drmLevel.hasStrictProtectionがFalse)の場合 : 注釈を表示しないこと
 */
export const PlaybackCheckerTag = (props: PlaybackCheckerTagProps) => {
  const { videoData } = props;
  const { content } = useQueryString();

  const hasStrictProtection = useMemo(() => {
    if (isVideoSeason(videoData)) {
      // get param contendIdが入ってない = シーズン末端 & 続きから見る情報がある場合
      if (videoData.continueWatching && !content) {
        return videoData.continueWatching?.content.drmLevel.hasStrictProtection;
        // episodeがある = エピソード末端
      } else if (videoData.episode) {
        return videoData.episode.drmLevel.hasStrictProtection;
        // シーズン末端 & 続きから見る情報がない場合
      } else {
        return videoData.episodes.edges[0]?.node.drmLevel.hasStrictProtection;
      }
    }

    if (isVideoSpotLiveSeason(videoData)) {
      return videoData.episodes.edges[0]?.node.drmLevel.hasStrictProtection;
    }

    if (isVideoLegacySeason(videoData)) {
      if (videoData.continueWatching) {
        return videoData.continueWatching?.content.drmLevel.hasStrictProtection;
      } else {
        return videoData.content.drmLevel.hasStrictProtection;
      }
    }

    return false;
  }, [videoData]);

  return hasStrictProtection ? (
    <Styled.DivSupplementBox>
      <Styled.SpanText>
        {`この動画の再生にはコンテンツ保護基準を満たした再生環境が必要です。`}
        <Styled.Anchor href={HELP_URL} target="_blank">{`再生できるか確認する`}</Styled.Anchor>
      </Styled.SpanText>
    </Styled.DivSupplementBox>
  ) : null;
};
